<div class="flex flex-col px-8 py-12">
  <form [formGroup]="form" class="flex flex-col" (ngSubmit)="submit()" (keyup.enter)="submit()">
    <section>
      <label class="body-small text-grey">
        {{ 'modules.evcSmallBiz.mailOfferForm.contactOptionsLabel' | translate }}
      </label>
      <h4 class="h4 text-grey-dark mb-8">
        {{ 'modules.evcSmallBiz.mailOfferForm.contactOptionsTitle' | translate }}
      </h4>

      <evsb-text-input
        class="block mb-4"
        formControlName="vatNumber"
        (keyup)="normalizeVatNumber()"
        [error]="invalid('vatNumber') && { error: 'modules.evcSmallBiz.form.validVATRequired' | translate }"
        [label]="{ label: 'modules.evcSmallBiz.virtualCheckup.vatNumber.label' | translate }"
        [placeholder]="'modules.evcSmallBiz.virtualCheckup.vatNumber.placeholder' | translate"
      ></evsb-text-input>

      <evsb-text-input
        class="block mb-4"
        formControlName="company"
        [error]="invalid('company') && { error: 'modules.evcSmallBiz.form.required' | translate }"
        [label]="{ label: 'modules.evcSmallBiz.mailOfferForm.company.label' | translate }"
        [placeholder]="'modules.evcSmallBiz.mailOfferForm.company.placeholder' | translate"
      ></evsb-text-input>

      <evsb-text-input
        class="block mb-4"
        formControlName="firstName"
        [error]="invalid('firstName') && { error: 'modules.evcSmallBiz.form.required' | translate }"
        [label]="{ label: 'modules.evcSmallBiz.mailOfferForm.firstName.label' | translate }"
        [placeholder]="'modules.evcSmallBiz.mailOfferForm.firstName.placeholder' | translate"
      ></evsb-text-input>

      <evsb-text-input
        class="block mb-4"
        formControlName="lastName"
        [error]="invalid('lastName') && { error: 'modules.evcSmallBiz.form.required' | translate }"
        [label]="{ label: 'modules.evcSmallBiz.mailOfferForm.lastName.label' | translate }"
        [placeholder]="'modules.evcSmallBiz.mailOfferForm.lastName.placeholder' | translate"
      ></evsb-text-input>

      <evsb-phone-input
        class="block mb-4"
        formControlName="telephone"
        (keyup)="normalizePhoneNumber()"
        [error]="invalid('telephone') && { error: 'modules.evcSmallBiz.form.validTelephoneRequired' | translate }"
        [label]="{ label: 'modules.evcSmallBiz.virtualCheckup.telephone.label' | translate }"
        [placeholder]="'modules.evcSmallBiz.virtualCheckup.telephone.placeholder' | translate"
      ></evsb-phone-input>

      <evsb-email
        class="block mb-4"
        formControlName="email"
        [error]="invalid('email') && { error: 'modules.evcSmallBiz.form.validEmailRequired' | translate }"
        [label]="{ label: 'modules.evcSmallBiz.mailOfferForm.email.label' | translate }"
        [placeholder]="'modules.evcSmallBiz.mailOfferForm.email.placeholder' | translate"
      ></evsb-email>

      <app-checkbox-input
        class="block mb-4"
        formControlName="alreadyClient"
        [error]="invalid('alreadyClient') && { error: 'modules.evcSmallBiz.form.required' | translate }"
        [label]="{ label: 'modules.evcSmallBiz.virtualCheckup.alreadyClient.label' | translate }"
      ></app-checkbox-input>

      <app-checkbox-input
        class="block mb-4"
        formControlName="consent"
        [error]="invalid('consent') && { error: 'modules.evcSmallBiz.form.required' | translate }"
        [label]="{ label: 'modules.evcSmallBiz.mailOfferForm.consent.label' | translate }"
      ></app-checkbox-input>
    </section>
  </form>
</div>
